import { useEffect, useRef } from "react";
import { toast } from "sonner";
import axios from "axios";
import { Flame } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SocialProofToast = () => {
  const idxRef = useRef(0);

  useEffect(() => {
    let timer;
    axios.get(`${API}/social-proof`).then((r) => {
      const { recent } = r.data;
      if (!recent || recent.length === 0) return;
      const show = () => {
        const e = recent[idxRef.current % recent.length];
        idxRef.current += 1;
        toast(
          <span className="flex items-center gap-2 text-sm" data-testid="social-proof-toast">
            <Flame className="w-4 h-4 text-[#A67C1E] shrink-0" />
            <span>
              Seseorang baru saja melirik <b>{e.product_name}</b>
              <span className="block font-mono text-[10px] text-[#211B10]/50 mt-0.5">{e.minutes_ago} menit yang lalu</span>
            </span>
          </span>,
          { duration: 4500, position: "bottom-left" }
        );
      };
      timer = setTimeout(function cycle() {
        show();
        if (idxRef.current < 4) timer = setTimeout(cycle, 22000);
      }, 8000);
    }).catch(() => {});
    return () => clearTimeout(timer);
  }, []);

  return null;
};
